import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CampoObrigatorio} from '../../validators/campo-obrigatorio';
import {AplicarRegraCampos} from '../../validators/aplicar-regra-campos';
import {MSG_OBG_TELEFONE} from '../../../../../tools/Mensagens';

@Component({
  selector: 'app-telefone',
  templateUrl: './telefone.component.html',
  styleUrls: ['./telefone.component.css']
})
export class TelefoneComponent implements OnInit, OnDestroy {

  @Input() formulario: FormGroup;
  @Input() telefone!: string;

  constructor() {
  }

  ngOnInit() {
    this.formulario.addControl('telefone', new FormControl(this.telefone ? this.telefone : '', Validators.required));
  }

  ngOnDestroy(): void {
    this.formulario.removeControl('telefone');
  }

  public validarFormulario() {
    const campos = [
      {control: 'telefone', mensagem: MSG_OBG_TELEFONE, regra: this.validarTelefone.bind(this)}
    ];
    AplicarRegraCampos.aplicar(campos, this.formulario);
  }

  private validarTelefone(value: any): boolean {
    return CampoObrigatorio.aplicar(value);
  }

}
